import { useEffect, useState } from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isUserCoach, isUserAdmin } from '../../lib/auth';
import { supabase } from '../../lib/supabase';
import { LogOut, ShieldCheck } from 'lucide-react';

export function SILayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/si/login', { replace: true });
      return;
    }
    Promise.all([isUserCoach(user.id), isUserAdmin(user.id)]).then(([coach, admin]) => {
      if (!coach && !admin) {
        navigate('/si/login', { replace: true });
      } else {
        setIsAdmin(admin);
        setChecking(false);
      }
    });
  }, [user, navigate]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/si/login', { replace: true });
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-brand-5 flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-success-40 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-5 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-20 sticky top-0 z-40">
        <div className="section-container flex items-center justify-between h-14">
          <Link to="/si/dashboard" className="flex items-center">
            <span className="text-sm font-semibold text-gray-80">Session Intelligence<sup className="text-[0.6em]">™</sup></span>
          </Link>

          <div className="flex items-center gap-2">
            {isAdmin && (
              <Link
                to="/si/admin"
                className="flex items-center gap-1.5 text-sm text-gray-50 hover:text-gray-80 transition-colors px-3 py-1.5 rounded-xl hover:bg-brand-5"
              >
                <ShieldCheck className="w-4 h-4" />
                <span className="hidden sm:block">Admin</span>
              </Link>
            )}
            <span className="hidden sm:block text-sm text-gray-50 mr-2">{user?.email}</span>
            <button
              onClick={handleSignOut}
              className="flex items-center gap-2 text-sm text-gray-50 hover:text-gray-80 transition-colors px-3 py-1.5 rounded-xl hover:bg-brand-5"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:block">Sign out</span>
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
